<template>
  <BaseInputSelect
    v-if="teams.length > 0"
    v-model="teamId"
    :label="$t('organization.assignTeam')"
    :items="items"
  />
</template>
<script setup lang="ts">
  import { computed, onMounted } from 'vue'
  import { useI18n } from 'vue-i18n'
  import BaseInputSelect from '@/core/components/base/form-fields/BaseInputSelect.vue'
  import useGet from '@/core/composables/api/useGet'
  import { useApplicationModule } from '@/core/composables/use-application-module'
  import { ApplicationModule } from '@/core/models/organization'
  import type { TeamListItem } from '../models/organization-team'

  const teamId = defineModel<string | undefined>()

  const { t } = useI18n()
  const { hasModule } = useApplicationModule()
  const { data, load } = useGet<TeamListItem[]>('teams')

  const teams = computed(() => data.value ?? [])

  const items = computed(() => [
    {
      id: undefined,
      title: t('organization.noTeam'),
      selected: !teamId.value,
      leadingIcon: 'remove',
    },
    ...teams.value.map((team) => ({
      id: team.id,
      title: team.name,
      selected: team.id === teamId.value,
      leadingIcon: 'groups',
    })),
  ])

  onMounted(() => {
    if (hasModule(ApplicationModule.LUMIA)) {
      load()
    }
  })
</script>
